<template>
    <div class="container">
        <div class="left" :style="{ width: true ? autoWidth + 'px' : '320px' }">
            <slot name="left"></slot>
        </div>
        <div class="center">
            <slot name="center"></slot>
        </div>
        <div v-if="originalShowRight" class="right" :style="{ width: autoWidth + 'px' }">
            <slot name="right"></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        showRight: {
            type: Boolean,
            default: true
        }

    },
    data() {
        return {
            autoWidth: 320,
            originalShowRight: null
        }
    },
    watch:{
      'showRight':{
        immediate:true,
        handler(val){
          this.originalShowRight = _.cloneDeep(val)
        }
      }
    },
    created() {
        //监听页面变化
        let that = this
        // that.originalShowRight = _.cloneDeep(this.showRight)
        that.getClientWidth()
        window.addEventListener('resize', _.debounce(that.getClientWidth, 150));
    },
    methods: {
        //计算页面宽度变化
        getClientWidth() {
            const availableWidth = document.body.clientWidth; // 获取浏览器窗口的可用宽度
            if (availableWidth < 1200) {
                this.autoWidth = 200
                this.originalShowRight = this.showRight
            } else if (availableWidth < 1440 && (availableWidth > 1200)) {
                this.autoWidth = 270
                this.originalShowRight = this.showRight
            } else if ((1440 < availableWidth) && (availableWidth < 1512)) {
                this.autoWidth = 290
                this.originalShowRight = this.showRight
            } else {
                this.autoWidth = 320
                this.originalShowRight = this.showRight
            }
        },
    }

}
</script>

<style lang="less" scoped>
.container {
    background-color: #F4F4F4;
    display: flex;
    height: 100%;

    .center {
        height: 100%;
        flex: 1;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        overflow-x: auto;
    }
}
</style>